// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"loader_loaderWrapper__3uBwA","logoContainer":"loader_logoContainer__MY0h9","spinner":"loader_spinner__2NFaj"};